export const NET_UP = 1;
export const NET_WAIT = 0;
export const NET_DOWN = -1;